/* eslint-disable no-console */
export const useLogger = (displayId: string) => {
  const { loginUser } = useLoginUserStore();
  const _formatLog = (
    level: 'debug' | 'info' | 'warn' | 'error',
    message: string,
    context?: Record<string, unknown>,
  ) => {
    const currentDatetime = toJpISOString(new Date());
    const userId = loginUser?.platId ? `[${loginUser.platId}]` : '';
    const ctx = context ? ` ${JSON.stringify(context)}` : '';
    return `[${currentDatetime}] [${level.toUpperCase()}] [${displayId}] ${userId} ${message} ${ctx}`;
  };

  const debug = (message: string, context?: Record<string, unknown>) => {
    const formattedMessage = _formatLog('debug', message, context);
    console.debug(formattedMessage);
  };

  const info = (message: string, context?: Record<string, unknown>) => {
    const formattedMessage = _formatLog('info', message, context);
    console.log(formattedMessage);
  };

  const warn = (message: string, error?: Error, context?: Record<string, unknown>) => {
    if (error) {
      context = {
        ...context,
        error: {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
      };
    }
    const formattedMessage = _formatLog('warn', message, context);
    console.warn(formattedMessage);
  };

  const error = (message: string, error?: Error, context?: Record<string, unknown>) => {
    if (error) {
      context = {
        ...context,
        error: {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
      };
    }
    const formattedMessage = _formatLog('error', message, context);
    console.error(formattedMessage);
  };

  return {
    debug,
    info,
    warn,
    error,
  };
};
